import { render } from "./App.vue?vue&type=template&id=3f7f347f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3f7f347f&lang=scss"

import exportComponent from "D:\\xsq\\xsq\\2023project\\知音邮政项目\\zhiyin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__